var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.048 14.398"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".alert_svg__cls-1{fill:#fa0043}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__alert",
    transform: "translate(0 -26.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__Group_16815",
    transform: "translate(0 26.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__Group_16814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "alert_svg__Path_31166",
    d: "M15.792 37.883L9.658 27.259a1.887 1.887 0 00-3.268 0L.256 37.883a1.887 1.887 0 001.634 2.83h12.268a1.887 1.887 0 001.634-2.83zm-.814 1.417a.937.937 0 01-.82.473H1.89a.947.947 0 01-.82-1.42L7.2 27.729a.947.947 0 011.64 0l6.134 10.624a.937.937 0 01.004.947z",
    className: "alert_svg__cls-1",
    transform: "translate(0 -26.315)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__Group_16817",
    transform: "translate(7.554 31.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__Group_16816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "alert_svg__Rectangle_17704",
    d: "M0 0h.94v4.701H0z",
    className: "alert_svg__cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__Group_16819",
    transform: "translate(7.397 36.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_svg__Group_16818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "alert_svg__Path_31167",
    d: "M236.629 355.99a.627.627 0 10.627.627.628.628 0 00-.627-.627z",
    className: "alert_svg__cls-1",
    transform: "translate(-236.002 -355.99)"
  }))))));
}

export default SvgAlert;